module.exports = __webpack_public_path__ + "img/14.a540d0f2.jpg";